import { gql } from "@apollo/client";

export const FETCH_ASSESSMENT_CATEGORIES = gql`
  query FETCH_ASSESSMENT_CATEGORIES {
    esgAssessmentCategories {
      id
      name
    }
  }
`;

export const FETCH_ASSESSMENT_CATEGORY_SUMMARY = gql`
  query FETCH_ASSESSMENT_CATEGORY_SUMMARY($assessmentCategoryId: ID!) {
    esgAssessmentReport(assessmentCategoryId: $assessmentCategoryId)
    esgAssessmentCategory(assessmentCategoryId: $assessmentCategoryId) {
      id
      name
    }
  }
`;
